import { ErrorReference } from '../../types';

export const USER_NOT_FOUND: ErrorReference = {
  server: {
    error_type: 'USER_ERROR',
    error_code: 'USER_NOT_FOUND',
    error_message:
      'The User you requested cannot be found. This User does not exist or has had access removed by the user.',
    display_message: null,
    http_code: 404,
  },
  link: null,
};
